import { toParagraphSlug } from '#shared/utils/urls'
import { array, nonEmpty, object, parse, pipe, string, transform } from 'valibot'

const KEY = 'lovId'

const paramsSchema = object({
  [KEY]: pipe(
    array(string()),
    transform(([rawLawId, ...parts]) => {
      const lawId = parse(pipe(string(), nonEmpty()), rawLawId)
      const lawFragmentId = parts.filter(Boolean).join('/')
      const paragraph = extractParagraph(parts)

      return {
        lawId,
        lawFragmentId,
        paragraph,
        nodeId: [lawId, lawFragmentId].filter(Boolean).join('/'),
      }
    }),
  ),
})

export function useLawRouteParams() {
  const route = useRoute()

  return computed(() => parse(paramsSchema, route.params)[KEY])
}

function extractParagraph(parts: string[]) {
  for (const raw of parts) {
    const paragraph = toParagraphSlug(raw)
    if (paragraph) {
      return paragraph
    }
  }
  return null
}
